import ButtonWrap from '@/components/ButtonWrap';
import { Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import './style.scss';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <>
            <Result
                className="p-not-found"
                status="404"
                title="404"
                subTitle="PAGE_NOT_FOUND"
                extra={<ButtonWrap onClick={() => navigate(-1)} type="primary" text="QUAY LẠI" />}
            />
        </>
    );
};

export default NotFound;
